import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { api } from "@/lib/api";
import { ScreenHeader, Spinner } from "@/components/kit";
import { Page } from "@/components/layout";

export default function Legal() {
  const { kind } = useParams();
  const [doc, setDoc] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    api("/legal").then(setDoc).catch((e) => setErr(e.message));
  }, []);
  const isTerms = kind === "terms";
  return (
    <div data-testid="legal-screen">
      <ScreenHeader testId="legal-screen-back" label="BREEZ" fallback="/privacy" />
      <Page className="flex flex-col gap-4 pb-12">
        <h1 className="t-h1">{isTerms ? "Terms of use" : "Privacy policy"}</h1>
        {err ? <p className="t-body">{err}</p> : !doc ? <Spinner /> : (
          <div className="rounded-[20px] border border-line bg-white p-5">
            <p data-testid="legal-body" className="t-body whitespace-pre-line !leading-6">{isTerms ? doc.terms : doc.privacy_policy}</p>
            <p className="t-caption mt-4">Privacy requests: {doc.privacy_contact}</p>
          </div>
        )}
      </Page>
    </div>
  );
}
